var acc = document.getElementsByClassName('odeo-accordion');
var i;
var selected;
var globalMyInterval;
var globalFinalInterval;

document.onload = addClickListenerOdeoAccordion();

function updateScrollHeight(panel) {
	panel.style.maxHeight = panel.scrollHeight + 'px';
}

function cutIntervals(panel, myInterval, finalInterval) {
	var maxHeight = panel.style.maxHeight;
	var scrollHeight = panel.scrollHeight + 'px';
	if (maxHeight == scrollHeight) {
		clearInterval(myInterval);
		clearInterval(finalInterval);
	}
}

function togglePanel(param) {
	// console.log(param);
	if (acc.length > 0 && param) {
		param.classList.toggle('odeo-active');
		var panel = param.nextElementSibling;
		cutIntervals(panel, globalMyInterval, globalFinalInterval);
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + 'px';
		}
		for (n = 0; n < acc.length; n++) {
			if (panel !== acc[n].nextElementSibling) {
				acc[n].nextElementSibling.style.maxHeight = null;
				acc[n].classList.remove('odeo-active');
			}
		}

		if (param.classList.contains('odeo-active')) {
			var myInterval = setInterval(function () {
				updateScrollHeight(panel);
			}, 100);

			var finalInterval = setInterval(function () {
				cutIntervals(panel, myInterval, finalInterval);
			}, 1000);

			globalMyInterval = myInterval;
			globalFinalInterval = finalInterval;
		}
	}
}

function addClickListenerOdeoAccordion() {
	for (i = 0; i < acc.length; i++) {
		if (acc.length > 0) {
			if (!acc[i].classList.contains('accordionEventListening')) {
				acc[i].addEventListener('click', function () {
					let x = this;
					for (a = 0; a < acc.length; a++) {
						if (x != acc[a]) {
							acc[a].classList.remove('odeo-active');
							var panel = acc[a].nextElementSibling;
							cutIntervals(panel, globalMyInterval, globalFinalInterval);
						}
					}
					togglePanel(this);
				});
			}
			acc[i].classList.add('accordionEventListening');
		}
	}
}

window.addEventListener(
	'resize',
	function (event) {
		if (acc.length > 0) {
			let x = acc[selected];
			for (a = 0; a < acc.length; a++) {
				if (x != acc[a]) {
					acc[a].classList.remove('odeo-active');
					var panel = acc[a].nextElementSibling;
					cutIntervals(panel, globalMyInterval, globalFinalInterval);
				}
			}
			for (i = 0; i < acc.length; i++) {
				acc[i].classList.remove('odeo-active');
				var panel = acc[i].nextElementSibling;
				if (panel.style.maxHeight) {
					selected = i;
				}
				panel.style.maxHeight = null;
			}
			togglePanel(acc[selected]);
		}
	},
	true
);
